export default __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-a8a30180df21c85e4ed793d48b296ffb.png";